import { enc, query, request } from './http';

export const createTileTicket = (body, options) => request('POST', `/api/madar/map/tile-ticket`, body, options);
export const getDataVersion = (options) => request('GET', `/api/madar/map/data-version`, undefined, options);
export const getRegionSummary = (options) => request('GET', '/api/madar/map/region-summary', undefined, options);
export const listWorkspaces = (filters, options) => request('GET', `/api/madar/map/workspaces${query(filters)}`, undefined, options);
export const createWorkspace = (body, options) => request('POST', `/api/madar/map/workspaces`, body, options);
export const updateWorkspace = (id, body, options) => request('PUT', `/api/madar/map/workspaces/${enc(id)}`, body, options);
export const deleteWorkspace = (id, options) => request('DELETE', `/api/madar/map/workspaces/${enc(id)}`, undefined, options);

// The tile route is not beneath any capability-wrapped prefix. Tickets already
// bind carrier, actor and canonical filter; no browser-supplied carrier is used.
export function tileUrl({ z, x, y, ticket, version, filterHash }) {
  if (!Number.isInteger(z) || z < 12 || z > 16 || !Number.isInteger(x) || !Number.isInteger(y)
      || x < 0 || y < 0 || x >= 2 ** z || y >= 2 ** z || !ticket || !filterHash || version == null) return null;
  return `/api/madar-tiles/${z}/${x}/${y}.png${query({ k: ticket, v: version, f: filterHash })}`;
}
